module.exports = __webpack_public_path__ + "img/jugend.a0372b43.png";